import React from 'react';
import * as RiIcons from 'react-icons/ri';
import { cat_reduccion, guardarReduccion } from '../firebase';
import Select from 'react-select';

function MedirReduccion ( props ) {
  console.log(props.user.email)
  const [categoria, setCategoria] = React.useState(null);
  const [catGuardar, setCatGuardar] = React.useState(null);
  const [subcategoria, setSubcategoria] = React.useState(null);
  const [subcatGuardar, setSubcatGuardar] = React.useState(null);
  const [subs, setSubs] = React.useState([])

  const [emisiones, setEmisiones] = React.useState([])
  const [emisionGuardar, setEmisionGuardar] = React.useState([])
  const [emisionAsociada, setEmisionAsociada] = React.useState('');
  const [emisionCode, setEmisionCode] = React.useState('');

  const [nombre, setNombre] = React.useState('');  
  const [tipoReduccion, setTipoReduccion] = React.useState('');
  const [fechaIncial, setFechaInicial] = React.useState();
  const [fechaFinal, setFechaFinal] = React.useState();
  const [porcentaje, setPorcentaje] = React.useState(0)
  
  // Cambia los datos de subcategoria cuando se cambia de categoria
  const onChangeCategoria = (obj) => {
    setCategoria(obj);
    setCatGuardar(obj.nombre);
    setSubs(obj.subcategorias);
    setSubcategoria(null);
    setEmisionAsociada(null)
  };
  // Cambia dato de subcategoria cuando detecta la selección
  const onChangeSubcategoria = (obj) => {
    setSubcategoria(obj);
    setSubcatGuardar(obj.nombre);
    setEmisiones(obj.emisiones)
    setEmisionAsociada(null)
  };
  // Cambia dato de emision de acuerdo selección
  const onChangeEmision = (obj) => {
    setEmisionAsociada(obj);
    setEmisionGuardar(obj.nombre);
    setEmisionCode(obj.code);
  }

  const onChangeNombre = (event) => {
    setNombre(event.target.value);
  }

  const onChangeTipoReduccion = (event) => {
    setTipoReduccion(event.target.value);
  }

  const onChangeFechaInicial = (event) => {
    setFechaInicial(event.target.value);
  }

  const onChangeFechaFinal = (event) => {
    setFechaFinal(event.target.value);
  };
  const onChangePorcentaje = (event) => {
      setPorcentaje(event.target.value);
  }
  
  const onSubmit = async (event) => {
    event.preventDefault();
      let reduccion = {
        nombre: nombre,
        categoria: catGuardar,
        subcategoria: subcatGuardar,
        code: emisionCode,
        empresa: 'Fibtex',
        year_inicio: Number(fechaIncial),
        year_final: Number(fechaFinal),
        emision_asociada: emisionGuardar,
        porcentaje_reduccion: Number(porcentaje),
        tipo_reduccion: tipoReduccion,
        user_email: props.user.email
      }

      guardarReduccion(reduccion)
  }

  const selectStyles = {
    control: (styles) => ({ ...styles, borderRadius: "20px"}),
    option: (styles, { isDisabled }) => {
      return {
        ...styles,
        backgroundColor: isDisabled ? "gray" : "white",
        color: "#000"
      }
    }
  }
  
  return (
    <div style={{ padding:'30px'  }} className='bg_div'>
      <div className='medicionMenu'>
        <h1>Reducción</h1>
        <form style={{border:'1px solid blue',padding:'20px',borderRadius:'25px',boxShadow:'0 6px 20px rgb(56 125 255 / 17%)'}} onSubmit={onSubmit}>
          <RiIcons.RiCloudWindyLine style={{color:'#1010C5',marginLeft:'5px'}}/>
          <label style={{ marginLeft:'10px'}}>Reducción</label>
          
          <div className="form-group">
              <label>Nombre</label>
              <input 
                type="text" 
                className="form-control" 
                value={nombre} 
                onChange={onChangeNombre} 
                placeholder="Nombre de entrada" 
              />
          </div>
        
          <div className="form-group" >
            <b>Categoria</b>
            <Select 
              styles={selectStyles}
              placeholder="Seleccione una categoría"
              value={categoria}
              options={cat_reduccion}
              onChange={onChangeCategoria}
              getOptionLabel={(x) => x.nombre}
              getOptionValue={(x) => x.id}
            />
            <br />
            <b>Subcategoria</b>
            <Select 
              styles={selectStyles}
              placeholder="Seleccione una subcategoría"
              value={subcategoria}
              options={subs}
              onChange={onChangeSubcategoria}
              getOptionLabel={(x) => x.nombre}
              getOptionValue={(x) => x.id}
            />
            <br />
            <b>Emisiones</b>
            <Select 
              styles={selectStyles}
              placeholder="Seleccione una emisión"
              value={emisionAsociada}
              options={emisiones}
              onChange={onChangeEmision}
              getOptionLabel={(x) => x.nombre}
              getOptionValue={(x) => x.id}
            />
          </div>
           
          <div  style={{ border:'none',background:'transparent'}} className='form-control'>
            <label style={{marginLeft: '15px'}}>Año inicio</label>
            <label style={{marginLeft: '143px'}}>Año final</label>
          </div>
          <div style={{ border:'none',background:'transparent'}} className='form-control'>
            <input type='text' style={{marginRight:'20px',borderRadius:'15px',padding:'3px 10px 3px 10px',border: '1px solid gray'}}  className='input__seguidos'  onChange={onChangeFechaInicial} placeholder='Año inicio'/>
            <input type='text' style={{marginRight:'20px',borderRadius:'15px',padding:'3px 10px 3px 10px',border: '1px solid gray'}}  className='input__seguidos' onChange={onChangeFechaFinal} placeholder='Año final'/>
          </div>
          <div className="form-group">
              <label>Porcentaje reducción esperada</label>
              <div style={{display:'flex'}}>
                <input required type="number" step='0.01' style={{width:'20%'}} className="form-control" value={porcentaje} onChange={onChangePorcentaje} placeholder="Porcentaje reducción ejemplo 10%"/>
                <label style={{top:'7px',position:'relative','left':'5px'}}>%</label>
              </div>
          </div>
          <div className="form-group" onChange={onChangeTipoReduccion}>
              <label style={{marginTop:'10px'}}>Tipo de reducción </label>
              <br/>
              <label > 
              <input style={{marginLeft:'15px',accentColor:'green'}} defaultChecked type='radio' value='Anual'  name='tipoReduccion' ></input>
              <label style={{marginLeft:'15px'}}>
                <label>Anual</label>
              </label>
              </label>
              <label >
                <input style={{marginLeft:'15px',accentColor:'green'}} type='radio' value='Acumulada' name='tipoReduccion' ></input>
                <label style={{marginLeft:'15px'}}>
                  <label>Acumulada</label>
                </label>
              </label>
          </div>
          <button className='boton__agregar__entrada'>Agregar entrada</button>
        </form>
        
      </div>
    </div>
  )
}

export { MedirReduccion }

/*const cat_reduccion = [
    {
      id:1, 
      nombre: "Transporte", 
      subcategorias: [
        {
          id: 1, 
          nombre: 'Transporte terrestre', 
          emisiones:[
              {id: 1, nombre: 'Transporte trabajo'},
              {id: 2, nombre: 'Transporte materia prima'},
          ]
        },{
          id: 2, 
          nombre: 'Transporte aéreo', 
          emisiones:[
              {id: 1, nombre: 'Transporte aéreo'},
          ]
        },{
          id: 3, 
          nombre: 'Transporte marítimo', 
          emisiones:[
              {id: 1, nombre: 'Transporte marítimo'}
          ]
        }
      ]
    },{
      id:2,
      nombre: "Consumo de energía",
      subcategorias: [
        { id: 1, 
          nombre: "Consumo de energía eléctrica",
          emisiones: [
            {id:1, nombre: 'Consumo de energía'}
          ]
        },
      ] 
    }
]*/